





import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'AccordionItemToggleIcon',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
});
